import Vue from 'vue'
import Vuex from 'vuex'
import { URLSearchParams } from '@/utils'
import { postLead, patchtLead, getAppSettings } from '@/api/services'

Vue.use(Vuex)

const state = {
  appSettings: {},
  docsToast: false,
  intervals: [],
  lead: {},
  multiplier: null,
  numeroParcelas: 11,
  minimalInstallmentValue: 5,
  params: {},
  policyNumber: null,
  device: null,
  quotedDevice: null,
  purchase: {
    payment: null,
    personalData: null,
    phoneDetail: null,
    promoCode: null
  }
}

const { lead_uuid: leadUuid, ...params } = URLSearchParams()

Object.assign(state.params, params)

state.device = JSON.parse(sessionStorage.getItem('ciclic:device')) || null
state.lead.uuid = leadUuid || sessionStorage.getItem('leadUuid') || null
state.quotedDevice = JSON.parse(sessionStorage.getItem('ciclic:quotedDevice')) || null

if (params.code) {
  sessionStorage.code = params.code
}

const getters = {
  numeroParcelas: state => state.numeroParcelas,
  policyNumber: state => state.policyNumber,
  multiplier: state => state.multiplier,
  policyUuid: state => state.device.payment.policyUuid,
  purchase: state => state.purchase,
  intervals: state => state.intervals
}

const mutations = {
  setAppSettings (state, payload) {
    state.appSettings = payload
  },
  changeLead (state, payload) {
    state.lead = payload
  },
  changeQuotedDevice (state, payload) {
    state.quotedDevice = payload
  },
  change (state, numeroParcelas) {
    state.numeroParcelas = numeroParcelas
  },
  policyNumber (state, policyNumber) {
    state.policyNumber = policyNumber
  },
  multiplier (state, multiplier) {
    state.multiplier = multiplier
  },
  payment (state, payment) {
    state.purchase.payment = payment
  },
  personalData (state, personalData) {
    state.purchase.personalData = personalData
  },
  phoneDetail (state, phoneDetail) {
    state.purchase.phoneDetail = phoneDetail
  },
  promoCode (state, promoCode) {
    state.purchase.promoCode = promoCode
  },
  addInterval (state, interval) {
    state.intervals.push(interval)
  }
}

const actions = {
  async init ({ commit }) {
    try {
      const appSetting = await getAppSettings(params.client_id)

      commit('setAppSettings', {
        ...appSetting.data.global,
        ...appSetting.data.product.devices,
        hasLoaded: true
      })
    } catch (error) {
      this._vm.$sentry.logWithContext(
        { ctx: { step: `[init/getAppSettings]: error client_id ${params.client_id}` }, error }
      )

      commit('setAppSettings', { hasLoaded: true })
    }
  },
  actionPostLead ({ commit, rootState }, data) {
    return postLead({
      cookieGA: rootState.params._ga,
      data
    })
      .then(res => {
        commit('changeLead', {
          type: res.data.type,
          uuid: res.data.uuid
        })
        sessionStorage.setItem('leadUuid', res.data.uuid)
      })
      .catch(error => console.warn(`[actionPostLead] - ${error}`))
  },
  actionPatchLead ({ commit, rootState }, payload) {
    const { uuid, ...data } = rootState.lead

    return patchtLead({
      cookieGA: rootState.params._ga,
      uuid,
      data: {
        ...data,
        ...payload
      }
    })
      .then(res => {
        commit('changeLead', {
          type: res.data.type,
          uuid: res.data.uuid
        })
        sessionStorage.setItem('leadUuid', res.data.uuid)
      })
      .catch(error => console.warn(`[actionPatchLead] - ${error}`))
  }
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})

export default store
